import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { USER_URL } from '@insite-store360/shared';
import { catchError, Observable } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

export interface LandingPageSummaryCard {
  title: string;
  keyAccounts: string;
  dataCoverage: string;
}

export interface LandingPageCoverageRow {
  country: string;
  stores: string;
  projectStores: string;
  coverage: string;
  promoters?: string;
  tds?: string;
  total?: boolean;
}

export interface LandingPageCoverageTable {
  title: string;
  variant: 'india' | 'imea' | 'asia' | 'anz';
  compact?: boolean;
  rows: LandingPageCoverageRow[];
}

export interface LandingPageOverview {
  summaryCards: LandingPageSummaryCard[];
  coverageTables: LandingPageCoverageTable[];
  highlightCountryCodes: string[];
}

@Injectable({
  providedIn: 'root',
})
export class LandingPageService {
  private readonly api = `${USER_URL}/landing-page`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService,
  ) {}

  getOverview(): Observable<{ result: LandingPageOverview }> {
    return this.http
      .get<{ result: LandingPageOverview }>(`${this.api}/overview`)
      .pipe(catchError(this.errorHandler.handleError));
  }
}
